import { render, staticRenderFns } from "./NotifyGroupWizardStepTwo.vue?vue&type=template&id=13e930b4&scoped=true&"
import script from "./NotifyGroupWizardStepTwo.vue?vue&type=script&lang=js&"
export * from "./NotifyGroupWizardStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./NotifyGroupWizardStepTwo.vue?vue&type=style&index=0&id=13e930b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e930b4",
  null
  
)

export default component.exports